export default __webpack_public_path__ + "static/media/upgrade.d5ec0fde.svg";